import * as actionTypes from "./constants";

const resetPassword = (params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_PASSWORD_INIT_ACTION,
      value: params,
    });
  };
};

export default {
  resetPassword,
};
